import { ReactNode } from 'react';
import { TextInputField } from 'modules/templateEditor/common/components';
import { TextInputFieldProps } from 'modules/templateEditor/common/types';
import { FormField } from 'ui/formField';

type TextFormFieldProps = TextInputFieldProps & {
  helpText: string;
  labelText: string;
  errorText?: string | JSX.Element;
  hasError: boolean;
  isEditModeVisible: boolean;
  showSnippet: boolean;
  Suffix: ReactNode;
};

export const Text = ({
  helpText,
  labelText,
  hasError,
  errorText,
  isEditModeVisible,
  showSnippet,
  mediumDataKey,
  mediumDataValue,
  placeholderText,
  changeHandler,
  Suffix,
}: TextFormFieldProps) => {
  return (
    <FormField
      data-testid={`${mediumDataKey}-field`}
      helpText={isEditModeVisible ? helpText : null}
      isHorizontalLayout
      labelText={labelText}
      hasError={hasError}
      errorText={errorText}
    >
      <TextInputField
        mediumDataKey={mediumDataKey}
        mediumDataValue={mediumDataValue}
        changeHandler={changeHandler}
        placeholderText={placeholderText}
        showSnippet={showSnippet}
        Suffix={Suffix}
      />
    </FormField>
  );
};
